import { createGlobalStyle } from 'styled-components';

export const MachineDetailsMapGlobalStyled = createGlobalStyle`
  .ant-tooltip {
    .ant-tooltip-content {
      width: 350px;
    }
  }
`;
